<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="MinusDrillHeightStyle"></div>
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
  </div>
</template>

<script>
import util from "@/option/common/util";

export default {
  name: "mixBar",
  data() {
    return {
      formatter: (params, data) => {
        let content = '';
        if (!this.option.tipContent) {
          this.option.tipContent = ['维度值', '指标名', '指标值']
        }
        if (this.option.tipContent?.includes('维度值')) {
          content += `<div>${params[0].name}</div>`
        }
        params.forEach(item => {
          content += '<div>'
          if (this.option.tipContent?.includes('指标名')) {
            content += `${item.seriesName}`
          }
          if (this.option.tipContent?.includes('指标值')) {
            if (this.option.tipContent?.includes('指标名')) {
              content += '：'
            }
            const unit = this.getUnit(item.seriesName)
            content += `${item.value}${unit}`
          }
          content += '</div>'
        })
        return content
      },
      labelFormatter: (params, data) => {
        let content = '';
        if (this.option.labelContent?.includes('维度值')) {
          content += `${params.name}`
        }
        if (this.option.labelContent?.includes('指标值')) {
          if (this.option.labelContent?.includes('维度值')) {
            content += '：'
          }
          const unit = this.getUnit(params.seriesName)
          content += `${params.value}${unit}`
        }
        return content
      }
    }
  },
  methods: {
    // 获取单位
    getUnit(name) {
      const fieldItem = this.prop.metrics.find(item => item.name === name || item.fieldName === name) || {}
      if (fieldItem?.set?.type === 'percent') {
        return '%'
      }
      return fieldItem?.set?.indexUnit || ''
    },
    handlerDimParam(param) {
      // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
      param.componentType = this.option.assistTip ? 'indexRingGraph' : undefined;
      return param
    },
    hexColorToRGBA(hex, alpha) {
      const rgb = [] // 定义rgb数组
      if (/^\#[0-9A-F]{3}$/i.test(hex)) { // 判断传入是否为#三位十六进制数
        let sixHex = '#'
        hex.replace(/[0-9A-F]/ig, function (kw) {
          sixHex += kw + kw // 把三位16进制数转化为六位
        })
        hex = sixHex // 保存回hex
      }
      if (/^#[0-9A-F]{6}$/i.test(hex)) { // 判断传入是否为#六位十六进制数
        hex.replace(/[0-9A-F]{2}/ig, function (kw) {
          // eslint-disable-next-line no-eval
          rgb.push(eval('0x' + kw)) // 十六进制转化为十进制并存如数组
        })
        return `rgba(${rgb.join(',')},${alpha / 100})` // 输出RGB格式颜色
      } else {
        return 'rgb(0,0,0)'
      }
    },
    updateChart() {
      const {
        chartSet: {
          axisLabelSet = {},
        },
        fontFamily = ''
      } = this.themeCfg
      const optionData = this.deepClone(this.dataChart);
      let option = {
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip({
          trigger: "axis",
          confine: true
        }),
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(),
        xAxis: this.getXAxisOption({
          data: optionData?.categories || [],
          boundaryGap: true,
          axisLabel: {
            show: this.validData(this.option.axisLabelShow, true),
            interval: this.option.xAxisInterval || 'auto',
            rotate: this.option.xAxisRotate || 0,
            textStyle: {
              color: this.option.xAxisColor || (axisLabelSet?.color || "#fff"),
              fontSize: this.option.xAxisFontSize || (axisLabelSet?.size || 14),
              fontFamily: this.option.xAxisFontFamily || fontFamily
            }
          }
        }),
        yAxis: [
          this.getYAxisOption({
            min: this.option.yAxisMinAuto ? null : this.option.yAxisMin,
            max: this.option.yAxisMaxAuto ? null : this.option.yAxisMax,
            interval: this.option.yAxisIntervalAuto ? null : this.option.yAxisInterval,
            minInterval: this.option.yAxisminInterval,
          }),
          this.getRightYAxisOption({
            position: "right",
            min: this.option.yAxisMinAuto ? null : this.option.yAxisMin,
            max: this.option.yAxisMaxAuto ? null : this.option.yAxisMax,
            interval: this.option.yAxisIntervalAuto ? null : this.option.yAxisInterval,
            minInterval: this.option.yAxisminInterval,
          })
        ],
        series: (() => {
          let list = (optionData?.series || []).filter((ele) => {
            return ele.type == "bar"
          }).map((ele, index) => {
            const defaultColor = this.getColor(index)
            return {
              ...ele, ...{
                type: "bar",
                stack: this.option.stack && ele.stack,
                barWidth: this.option.barWidth || 16,
                barMinHeight: this.option.barMinHeight || 0,
                itemStyle: this.getHasProp(!this.switchTheme, {
                  color: defaultColor
                }, {barBorderRadius: this.option.barRadius || 0}),
                label: this.getOptionLabel({
                  position: this.option.labelPosition,
                })
              }
            };
          });
          const tmp = (optionData?.series || []).filter((ele) => {
            return ele.type == "line"
          }).map((ele, index) => {
            const defaultColor = this.getColor(optionData?.series.length - index)
            return {
              ...ele, ...{
                type: "line",
                yAxisIndex: 1,
                smooth: this.validData(this.option.smooth, true),
                showSymbol: this.validData(this.option.symbolShow, false),
                symbol: this.option.symbolKind,
                symbolSize: this.option.symbolSize || 10,
                areaStyle: (() => {
                  if (this.option.areaStyle) {
                    return {
                      opacity: 0.7
                    };
                  }
                })(),
                itemStyle: this.getHasProp(!this.switchTheme, {
                  color: defaultColor
                }, {barBorderRadius: this.option.barRadius || 0}),
                label: this.getOptionLabel({
                  position: this.option.labelPosition,
                }),
                labelLine: {
                  show: this.option.labelContent?.includes('引导线') || false
                },
                lineStyle: {
                  width: this.option.lineWidth || 1
                },
              }
            };
          })
          list = list.concat(tmp)
          return list;
        })()
      };
      if (this.isDataCenter) {
        let _op = this.getDimentionOption()
        const {
          categories = [],
          series = []
        } = _op
        option.xAxis.data = categories
        const {
          barNumber = 1,
          lineNumber = 1
        } = this.option
        let lineData = []
        let barData = []
        for (let i = 0; i < series.length; i++) {
          let y = series[i]
          if (i <= barNumber - 1) {
            y.type = 'bar'
            barData.push(...y.data)
            y.yAxisIndex = 0
          } else if (i > barNumber - 1 && i <= barNumber + lineNumber - 1) {
            y.type = 'line'
            y.yAxisIndex = barNumber > 0 ? 1 : 0
            lineData.push(...y.data)
          } else {
            y.type = 'bar'
            y.yAxisIndex = 0
            barData.push(...y.data)
          }
          if (y.type === 'line') {
            y = {
              ...y,
              ...{
                smooth: this.validData(this.option.smooth, true),
                showSymbol: this.validData(this.option.symbolShow, false),
                symbol: this.option.symbolKind,
                symbolSize: this.option.symbolSize || 10,
                areaStyle: (() => {
                  if (this.option.areaStyle) {
                    return {
                      opacity: 0.7
                    };
                  }
                })(),
                lineStyle: {
                  width: this.option.lineWidth || 1
                },
                itemStyle: this.getHasProp(!this.switchTheme, {
                  color: this.getColor(i)
                }),
                label: this.getOptionLabel({
                  position: this.option.labelPosition,
                }),
                labelLine: {
                  show: this.option.labelContent?.includes('引导线') || false
                },
                markLine: {
                  ...this.getMarkLineDefaultSet(),
                  lineStyle: {
                    width: this.option.yAxisMarkLineWidth || 1,
                    type: this.option.yAxisMarkLineType,
                    color: this.option.yAxisMarkLineColor || "#FF0000",
                  },
                  data: this.option.yAxisMarkLineShow && this.getMarklineOption()
                }
              }
            }
          } else {
            y = {
              ...y,
              ...{
                stack: this.option.stack,
                barWidth: this.option.barWidth || 16,
                barMinHeight: this.option.barMinHeight || 0,
                itemStyle: this.getHasProp(
                    !this.switchTheme,
                    {
                      color: this.getColor(i),
                    },
                    {barBorderRadius: this.option.barRadius || 0}
                ),
                label: this.getOptionLabel({
                  position: this.option.labelPosition,
                }),
                labelLine: {
                  show: this.option.labelContent?.includes('引导线') || false
                },
              }
            }
          }
          // color
          // y.itemStyle = {
          //   color: this.getColor(i)
          // }
          option.legend.data.push(y.name)
          option.series.push(y)
        }
        const maxBar = barData.length ? Math.max.apply(null, barData) : 0;
        const maxLine = lineData.length ? Math.max.apply(null, lineData) : 0;
        if (barNumber > 0 && lineNumber > 0) {
          option.yAxis = [
            {
              ...option.yAxis,
              name: '',
              type: 'value',
              min: 0,
              max: maxBar,
            },
            {
              ...option.yAxis,
              name: '',
              type: 'value',
              min: 0,
              max: maxLine,
            },
          ]
        }
        // 辅助指标显示在tooltip
        if (this.prop.assistMetrics && this.prop.assistMetrics.length && this.option.assistTip) {
          option.tooltip.formatter = (params) => util.assistMetricsToolFormatter(params, this.prop, this.dataChart, series)
        }
      }
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
  }
};

</script>
